import { css } from 'styled-components';
import { PRIMARY } from 'src/styles/palettes';
export const SCROLLBAR_WIDTH = 6;

const rootStyle = css`
  scrollbar-color: ${PRIMARY} #fff2;

  * {
    scrollbar-width: thin;
  }
`;

const infusedRootStyle = css`
  body {
    ${rootStyle}
  }
`;

const scrollbar = css`
  ::-webkit-scrollbar {
    background-color: #fff2;
    width: ${SCROLLBAR_WIDTH}px;
    height: ${SCROLLBAR_WIDTH}px;
    border-radius: 9px;

    :hover {
      background-color: #fff3;
    }
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${PRIMARY};
    border-radius: 9px;
    border: 2px solid #fff2;

    :hover {
      border: 1px solid #fff3;
    }
  }

  ::-webkit-scrollbar-button {
    display: none;
  }

  ${__BUILD_MODE__ === 'production' ? rootStyle : infusedRootStyle}
`;

export default scrollbar;
